export function list(params = null) {
    return axios({
        url: `/api/get-compinate-plate`,
        method: 'post',
        data: params,
    });
}
